const Features = () => {
  const features = [
    {
      icon: 'fas fa-language',
      color: 'from-cyan-500 to-blue-500',
      title: 'بالدارجة الجزائرية 100%',
      desc: 'كل المحتوى التعليمي مشروح بالدارجة الجزائرية باش تفهم بسهولة وبدون تعقيد'
    },
    {
      icon: 'fas fa-star',
      color: 'from-purple-500 to-pink-500',
      title: 'محتوى تفاعلي وممتع',
      desc: 'تجربة تعليمية عصرية وجذابة بمواد مرئية ومكتوبة وتفاعلية باش تتعلم بمتعة'
    },
    {
      icon: 'fas fa-users',
      color: 'from-blue-500 to-indigo-600',
      title: 'لكل الأعمار والمستويات',
      desc: 'محتوى تعليمي للأطفال من 3 سنين، وللكبار اللي يحبوا يتعلموا - كل واحد يلقى ما يناسبو'
    },
    {
      icon: 'fas fa-chalkboard-teacher',
      color: 'from-green-500 to-emerald-500',
      title: 'مواد تعليمية متنوعة',
      desc: 'فيديوهات، نصوص، عروض تقديمية، بطاقات تعليمية - كل حاجة منظمة باش تفهم مليح'
    },
    {
      icon: 'fas fa-chart-line',
      color: 'from-orange-500 to-red-500',
      title: 'تعلم بطريقة منهجية',
      desc: 'مسار تعليمي واضح ومنظم يأخذك خطوة بخطوة من البداية للنهاية'
    },
    {
      icon: 'fas fa-headset',
      color: 'from-indigo-500 to-purple-600',
      title: 'دعم متواصل',
      desc: 'فريقنا موجود باش يساعدك في أي وقت تحتاج فيه مساعدة أو استفسار'
    }
  ];

  return (
    <section className="relative z-10 py-24 bg-white" id="features">
      {/* Blue gradient blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 bg-primary/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 bg-blue-400/25 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-[900px] mx-auto mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full mb-6 font-semibold text-sm">
            <i className="fas fa-star"></i>
            <span>المميزات</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-text mb-6 leading-tight">
            علاش تختار <span className="text-primary">علمني</span>؟
          </h2>
          <p className="text-xl md:text-2xl text-text2 leading-relaxed">
            تجربة تعليمية متكاملة بالدارجة الجزائرية - للكبار والصغار
          </p>
        </div>

        {/* Features Grid */}
        <div className="max-w-[1200px] mx-auto grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 lg:gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group relative bg-white rounded-2xl md:rounded-3xl p-4 md:p-6 lg:p-8 border-2 border-gray-100 hover:border-primary/30 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl"
            >
              {/* Icon with gradient */}
              <div className="relative mb-3 md:mb-4 lg:mb-6">
                <div className={`w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-gradient-to-br ${feature.color} rounded-xl md:rounded-2xl flex items-center justify-center text-white text-lg md:text-2xl lg:text-3xl shadow-xl transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                  <i className={feature.icon}></i>
                </div>
                {/* Glow effect */}
                <div className={`absolute inset-0 w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 bg-gradient-to-br ${feature.color} rounded-xl md:rounded-2xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity`}></div>
              </div>

              {/* Content */}
              <h3 className="text-sm md:text-lg lg:text-2xl font-black text-text mb-2 md:mb-3 leading-tight">
                {feature.title}
              </h3>
              <p className="text-xs md:text-base lg:text-lg text-text2 leading-relaxed">
                {feature.desc}
              </p>

              {/* Hover arrow */}
              <div className="mt-3 md:mt-4 lg:mt-6 opacity-0 group-hover:opacity-100 transition-all hidden md:block">
                <div className="inline-flex items-center gap-2 text-primary font-bold">
                  <span className="text-sm">اكتشف المزيد</span>
                  <i className="fas fa-arrow-left text-sm group-hover:-translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
